import UserService from '@/service/user'
export default {
  openChat ({commit}, payload) {
    commit('openChat', payload)
  },
  closeChat ({commit}, payload) {
    commit('closeChat', payload)
  },
  receiveMessage ({commit}, payload) {
    commit('receiveMessage', payload)
  },
  insertNewWindownChat ({commit}, payload) {
    commit('insertNewWindownChat', payload)
  },
  chatSystem ({commit}, payload) {
    commit('sendMessage', payload)
    return new Promise((resolve, reject) => {
      UserService.chatSystem(payload.message.data.text).then(res => {
        commit('chatSystem', res.data)
        resolve('true')
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  sendMessage ({commit}, payload) {
    commit('sendMessage', payload)
    return new Promise((resolve, reject) => {
      console.log(payload)
      var body = {}
      var data = {}
      switch (payload.message.type) {
        case 'text':
          data.text = payload.message.data.text
          data.extra = ''
          break
        case 'emoji':
          data.text = payload.message.data.emoji
          data.extra = ''
          break
        case 'image':
          data.text = payload.message.data.text ? payload.message.data.text : ''
          data.extra = payload.message.data.file
          break
        case 'file':
          data.text = payload.message.data.text ? payload.message.data.text : ''
          data.extra = payload.message.data.file
          break
        default:
          data.text = payload.message.data.text ? payload.message.data.text : ''
          data.extra = ''
          break
      }
      body.data = data
      body.type = payload.message.type
      UserService.chat(payload.user, body).then(res => {
        resolve('true')
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/chat/actions.js